import React, { memo, createContext, useState, useContext, useEffect, useRef } from 'react';

export const AuthContext = createContext();
export const SetAuthContext = createContext()

export function useAuth() {
  return useContext(AuthContext);
}

export function useSetAuth() {
  return useContext(SetAuthContext)
}

export function AuthProvider({ children }) {
  // const token = useRef(null);
  // const setTFetchingStatus = useRef(true);
  // const fetchingError  = useRef(null);
  const [token, setToken] = useState(null);
  const [tFetchingStatus, setTFetchingStatus] = useState(true);
  const [tFetchingError, setTFetchingError] = useState(null);
  async function clearAuthData() {
    setToken(null)
    setTFetchingStatus(true)
    setTFetchingError(null)
    // token.current = null
    // setTFetchingStatus.current = true
    // fetchingError.current = null
  }


  useEffect(() => {
    try {
      const storedToken = window.localStorage.getItem('tokenBackoffice');
      if (storedToken) {
        setToken(storedToken);
        setTFetchingStatus(false);
      } else {
        setTFetchingError(true)
      }
    } catch (error) {
      // console.log(`found error in AuthContext`)
      setTFetchingError(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, tFetchingStatus, tFetchingError }}>
      <SetAuthContext.Provider value={{setToken, clearAuthData}} >
      {children}
      </SetAuthContext.Provider>
    </AuthContext.Provider>
  );
}